<div class="header fx-row fx-justify-space-between fx-items-center">
	<div class="description fx-row fx-justify-start fx-items-center" style="gap: 12px">
		<span class="material-icons-outlined">fact_check</span>
		<span class="label">{{'Servizi' | translate}}</span>
	</div>

	<div class="close-icon fx-row fx-justify-end fx-items-center">
		<span class="material-icons-outlined dialog-close-icon" (click)="onCloseClick()">close</span>
	</div>
</div>

<div class="trip-booking-services-container">
	<dataset-list
		[elevate]='false'
		[showSearchBar]='false'
		[showCreateForm]='false'
		[enableCreate]='false'
		[showTitle]='false'
		datasetCode='trip_booking_services'
		[parentDatasetACS]='parentDatasetACS'
		[parentDatasetRS]='parentDatasetRS'
		[filters]='{ trip_booking_package_id: tripBookingPackage.id }'
		[enableActions]='canEdit'
		[enableDelete]='canEdit'
		[enableEdit]='canEdit'
		tableStyle="style-3"
	></dataset-list>
</div>
<!-- footer -->
<div class="footer fx-row fx-justify-space-between fx-items-center">
	<div class="fx-row fx-justify-start fx-items-center" style="gap: 24px">
		<span class="label">{{'Totale' | translate}}:</span>
		<span class="value">{{ tripBookingPackage.total_amount | currency:"EUR" }}</span>
	</div>
	<div class="fx-row fx-justify-start fx-items-center">
		<button (click)="onRecalculateService()" class="add-service-btn mr-24 fx-row fx-justify-center fx-items-center" style="gap: 8px">
			<span class="material-icons-outlined">update</span> 
			<span class="btn-label">{{'Ricalcola costi' | translate}}</span>
		</button>
		<button (click)="addTripBookingService()" class="add-service-btn fx-row fx-justify-center fx-items-center" style="gap: 8px">
			<span class="material-icons-outlined">add</span> 
			<span class="btn-label">{{'Aggiungi servizio' | translate}}</span>
		</button>
	</div>
</div>